// import React from 'react';
// import { Link, Route } from 'react-router-dom';
// import { connect } from 'react-redux';

// // Actions
// import { gameActions } from '../../actions';

// import { GameForm } from './form';
// import { GameSetup } from './setup';
// import { GamePlayers } from './players';
// import { GameDebrief } from './debrief';

// import DebriefComposition from './debrief_composition';
// import DebriefInvestment from './debrief_investment';
// import DebriefInvestmentPrePost from './debrief_investment_pre_post';
// import DebriefIntervention from './debrief_intervention';
// import DebriefInterventionPrePost from './debrief_intervention_pre_post';
// import DebriefDownload from './debrief_download';

// // import { GameOffers } from './offers';
// // import { GameTypes } from './types';
// // import { GamePareto } from './pareto';

// import { GameLeaderboard } from './leaderboard';

// class Form extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       item: this.props.item || null,
//     };

//     // Bindings
//   }

//   componentDidMount() {
//     const { match } = this.props;
//     const { id } = match.params;
//     this.props.dispatch(gameActions.fetchGames(id));
//   }

//   render() {
//     const { game, match } = this.props;
//     // const { item } = this.state;
//     const SetupComponent =
//       game && game.data && game.data.access_type === 'lti-hbp'
//         ? GameSetup
//         : GameForm;

//     return (
//       <div>
//         {game && game.data && (
//           <div>
//             <Route exact path={match.path} component={SetupComponent} />
//             <Route
//               exact
//               path={match.path + '/players'}
//               component={GamePlayers}
//             />
//             {/* <Route path={match.path + '/players'} render={ props => <GamePlayers {...props} item={item} /> } /> */}
//             <Route
//               exact
//               path={match.path + '/debrief/overview'}
//               component={GameDebrief}
//             />
//             <Route
//               exact
//               path={match.path + '/debrief/composition'}
//               component={DebriefComposition}
//             />
//             <Route
//               exact
//               path={match.path + '/debrief/investment'}
//               component={DebriefInvestment}
//             />
//             <Route
//               exact
//               path={match.path + '/debrief/invprepost'}
//               component={DebriefInvestmentPrePost}
//             />
//             <Route
//               exact
//               path={match.path + '/debrief/intervention'}
//               component={DebriefIntervention}
//             />
//             <Route
//               exact
//               path={match.path + '/debrief/intprepost'}
//               component={DebriefInterventionPrePost}
//             />
//             <Route
//               exact
//               path={match.path + '/debrief/download'}
//               component={DebriefDownload}
//             />
//           </div>
//         )}
//       </div>
//     );
//   }
// }

// function mapStateToProps(state) {
//   const { player, game } = state;
//   return {
//     game,
//     player,
//   };
// }

// const connectedGamesPage = connect(mapStateToProps)(Form);
// export { connectedGamesPage as GameItem };

import React, { useEffect } from 'react';
import { Routes, Route, useParams, Navigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setupSocket, socketOn, enterBackend } from '../../helpers/sockets';

// Actions
import { gameActions } from '../../actions';

import GameForm from './form';
import GameFormHBP from './form_hbp';
import { GamePlayers } from './players';
import { GameDebrief } from './debrief';

import DebriefComposition from './debrief_composition';
import DebriefInvestment from './debrief_investment';
import DebriefInvestmentPrePost from './debrief_investment_pre_post';
import DebriefIntervention from './debrief_intervention';
import DebriefInterventionPrePost from './debrief_intervention_pre_post';
import DebriefDownload from './debrief_download';

const Form = () => {
  // Hooks
  const dispatch = useDispatch();
  const game = useSelector((state) => state.game);
  const { id } = useParams();

  useEffect(() => {
    dispatch(gameActions.fetchGames(id));

    // Fetch game data to connect to socket
    fetch(process.env.REACT_APP_API_URL + '/auth/oauth_provider')
      .then((res) => res.json())
      .then((data) => {
        // Validation
        if (!data?.io_domain) return console.log('No io_domain found');
        // Connect to ws
        setupSocket(data.io_domain, null, () => {
          if (id) {
            enterBackend({ game_id: id }, (gameData) => {
              console.log(`Connected to backend ${gameData?._id}`);
            });
            // Listen to game events
            socketOn('player', () => {
              dispatch(gameActions.fetchGames(id));
            });
          }
        });
      });
  }, [id]);

  // LOGIC
  const SetupComponent =
    game && game.data && game.data.access_type === 'lti-hbp'
      ? GameFormHBP
      : GameForm;

  // Location validations
  const { pathname } = window.location;
  const isSaved = game?.data?.status === 'saved';

  // When saved: Useful when creating a new run (snapshot)
  const redirectWhenSaved = ['/players', '/debrief'];
  if (isSaved && redirectWhenSaved.some((s) => pathname.includes(s))) {
    return <Navigate to={'/games/' + game?.data?._id} />;
  }

  return (
    <div>
      {game && game.data && (
        <div style={{ minHeight: '100vh' }}>
          <Routes>
            <Route index element={<SetupComponent />} />
            <Route path='setup' element={<SetupComponent />} />
            <Route path='players' element={<GamePlayers />} />

            {/* Redirect to debrief/composition */}
            <Route
              path='debrief'
              element={
                <Navigate to={`/games/${game.data._id}/debrief/composition`} />
              }
            />

            {/* Sim-specific */}
            <Route
              path='debrief/composition'
              element={<DebriefComposition />}
            />
            <Route path='debrief/investment' element={<DebriefInvestment />} />
            <Route
              path='debrief/invprepost'
              element={<DebriefInvestmentPrePost />}
            />
            <Route
              path='debrief/intervention'
              element={<DebriefIntervention />}
            />
            <Route
              path='debrief/intprepost'
              element={<DebriefInterventionPrePost />}
            />
            <Route path='debrief/download' element={<DebriefDownload />} />
          </Routes>
        </div>
      )}
    </div>
  );
};

export { Form as GameItem };
